import React, { useEffect, useState } from 'react';
import { SearchSharp } from '@mui/icons-material';
import ActivityIndicator from './ActivityIndicator';
import { API_GATEWAY_URL, IS_IPAD } from './utils';

const getAutocompleteResults = async (query) => {
  const url = new URL(`${API_GATEWAY_URL}/results`);
  const params = new URLSearchParams({ query });
  const response = await fetch(`${url}?${params}`);
  const data = await response.json();
  return data;
};

export function FetchingLocationBar() {
  return (
    <div className="frosted">
      <div style={{
        display: 'flex',
        alignItems: 'center'
      }}
      >
        <SearchSharp style={{ marginLeft: '8px' }} />
        <div style={{ margin: '8px 0', flexGrow: 2 }}>
          <i>Fetching location...</i>
        </div>
        <div className="col-auto d-flex align-items-center" style={{ marginRight: '8px' }}>
          <ActivityIndicator style={{ width: '30px' }} />
        </div>
      </div>
    </div>
  );
}

export default function GeoSearch({ setSelectedSearchResult }) {
  const [inputValue, setInputValue] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [query, setQuery] = useState();

  useEffect(() => {
    if (!inputValue || !inputValue.length) {
      setSearchResults([]);
      return () => {};
    }
    const timer = setTimeout(() => {
      setQuery(inputValue);
    }, 250);
    return () => clearTimeout(timer);
  }, [inputValue]);

  useEffect(() => {
    if (!query || !query.length) return;
    const task = async () => {
      const newResults = await getAutocompleteResults(query);
      setQuery();
      setSearchResults(newResults);
    };
    task();
  }, [query]);

  return (
    <div className="geosearch frosted">
      <div style={{
        display: 'flex',
        alignItems: 'center'
      }}
      >
        <SearchSharp style={{ marginLeft: '8px' }} />
        <input
          type="text"
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus={!IS_IPAD}
          style={{
            outline: 'none',
            fontSize: '18px',
            background: 'none',
            color: 'white',
            border: 'none',
            height: '40px',
            padding: 0,
            marginLeft: '4px',
            flexGrow: 1
          }}
          value={inputValue}
          onChange={(event) => setInputValue(event.target.value)}
          placeholder="Search for a location..."
        />
        {query && (
          <div className="col-auto d-flex align-items-center" style={{ marginRight: '8px' }}>
            <ActivityIndicator style={{ width: '30px' }} />
          </div>
        )}
      </div>
      <div className="search-results">
        {searchResults.map((result) => (
          <div
            key={result.placeID}
            className="search-result"
            onClick={() => {
              setInputValue('');
              setSelectedSearchResult(result);
              setSearchResults([]);
            }}
          >
            <div className="search-result-label">{result.name}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
